
    <div class="app-header">
      <div class="wrapper">
        <img src="assets/img/logo.svg" alt="">
        <div 
          class="app-header__user-info"
          *ngIf="user?.authenticated">
          <span (click)="logoutUser()"></span>
        </div>
      </div>
    </div> 
  